import { ICategory } from 'models/Category';
import { MOCK_HRC1155, MOCK_HRC721 } from './constants';

const categories: ICategory[] = [
  {
    address: MOCK_HRC721,
    category: 'character',
    name: 'Characters',
    type: 'ERC721',
  },
  {
    address: MOCK_HRC721,
    category: 'companion',
    name: 'Companions',
    type: 'ERC721',
  },
  {
    address: MOCK_HRC721,
    category: 'land',
    name: 'Lands',
    type: 'ERC721',
  },
  {
    address: MOCK_HRC1155,
    category: 'item',
    name: 'Items',
    type: 'ERC1155',
  },
  {
    address: MOCK_HRC1155,
    category: 'resource',
    name: 'Resources',
    type: 'ERC1155',
  },
  {
    address: MOCK_HRC1155,
    category: 'structure',
    name: 'Structures',
    type: 'ERC1155',
  },
];

export default categories;
